export const isNumeric = (value: any) => {
	// Trim whitespaces, reject empty strings, then check with Number()
	return (
		typeof value === 'number' ||
		(typeof value === 'string' && value.trim() !== '' && !isNaN(Number(value)))
	);
};
